import { Layer, Source } from 'react-map-gl';
import { useMemo, type JSX } from 'react';
import { shipClusterCountLayer, shipClusterLayer, unclusteredShipLayer } from '../constants/layers-config';
import { getShipClusters } from '../utils/layer-utils';
import { layerSources, vesselsClusterMaxZoomLevel } from '../constants/constants';
import { type MmsiKey, type VesselPosition, type VesselViewModel } from '../../../types';

interface Props {
  zoomLevel: number;
  vesselPositions: VesselPosition[];
  vesselData: Record<MmsiKey, VesselViewModel>;
}

const ClusterLayer = ({ vesselPositions, vesselData, zoomLevel }: Props): JSX.Element => {
  const features = useMemo(() => {
    return getShipClusters(vesselPositions, vesselData, zoomLevel, vesselsClusterMaxZoomLevel);
  }, [vesselPositions, vesselData, zoomLevel]);

  return (
    <Source
      id={layerSources.vesselClusters}
      type="geojson"
      data={{
        type: 'FeatureCollection',
        features,
      }}
      generateId
      cluster
      clusterMaxZoom={vesselsClusterMaxZoomLevel}
      clusterRadius={50}
    >
      <Layer {...shipClusterLayer} />
      <Layer {...shipClusterCountLayer} />
      <Layer {...unclusteredShipLayer} />
    </Source>
  );
};

export default ClusterLayer;
